'use client'

import { AddToCartButton } from '@/AddToCartButton'
import type { ProductDisplayOption } from '../../helpers/productOptions'

export const AddToCartCta = ({
  productId,
  productName,
  options,
  hasDownloads,
  isPreorder,
  preorderReleaseDate,
  label,
  /** When set, price label and add-to-cart use only this option (e.g. deluxe vs standard). */
  optionIndex,
  className,
}: AddToCartCtaProps) => {
  const selected = optionIndex != null ? options[optionIndex] : undefined
  const scopedOptions =
    optionIndex != null && selected != null ? [selected] : options
  const firstOption = scopedOptions[0]
  const effectivePrice = firstOption
    ? firstOption.salePrice ?? firstOption.price
    : null
  const priceLabel =
    effectivePrice != null
      ? `${firstOption.currencySymbol}${effectivePrice.toFixed(2)}`
      : null

  return (
    <AddToCartButton
      productId={productId}
      productName={productName}
      options={scopedOptions}
      independentOptionSelection={optionIndex != null}
      className={['w-full sm:w-auto', className].filter(Boolean).join(' ')}
      configureFlowLinkClassName="inline-block w-full sm:w-auto"
      showEmailNotification={true}
      hasDownloads={hasDownloads}
      isPreorder={isPreorder}
      preorderReleaseDate={preorderReleaseDate}
    >
      {priceLabel ? `${label} (${priceLabel})` : label}
    </AddToCartButton>
  )
}

interface AddToCartCtaProps {
  productId: number
  productName: string
  options: ProductDisplayOption[]
  hasDownloads: boolean
  isPreorder: boolean
  preorderReleaseDate: string | null
  label: string
  optionIndex?: number
  className?: string
}
